export const servicePath: string = "api/";

export const transitionDurationSpinners: number = 200;

export const apiDateFormat: string = "YYYY-MM-DD";

export const timeFormat: string = "HH:mm";

export const fullTimeFormat: string = "HH:mm:ss";

export const fullDateInStringFormat: string = "ddd DD MMM YYYY";

export const displayDateFormat: string = "DD/MM/YYYY";

export const sessionLogoutUrl: string = "/sso-logout/?redirect-url=/";

export const sessionExpiredUrl: string = "/sso-logout/?state=sto";

export const dashboardUrl: string = "/dashboard";

export const sessionExpiredTime: number = 900000; // 15 MINUTES